import { render, staticRenderFns } from "./SolicitacoesTreinamentoCriar.vue?vue&type=template&id=aa564064"
import script from "./SolicitacoesTreinamentoCriar.vue?vue&type=script&lang=js"
export * from "./SolicitacoesTreinamentoCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports